
import React, { createContext, useContext, useEffect, useState } from 'react';

import _omit from 'lodash.omit';











































const defaults = {
  state: {
    allBrandPresets: [],
    assetsMap: new Map(),
    displayType: 'LANDING',
    selectedId: '',
    returnDataType: 'ID',
    disabled: false,
    presetLoading: true
  },
  actions: {
    getBrandPresetsList: Function.prototype,
    setAllBrandPresets: Function.prototype,
    createBrandPreset: Function.prototype,
    updateBrandPreset: Function.prototype,
    updateBrandPresetApi: Function.prototype,
    brandPresetActionsApi: Function.prototype,
    getBrandPresetApi: Function.prototype,
    fetchAssets: Function.prototype,
    onSelectBrandPreset: Function.prototype
  }
};
// $FlowFixMe
const BrandPresetContext = createContext(defaults);

export default BrandPresetContext;

export function useBrandPresetContext() {
  return useContext(BrandPresetContext);
}

const createNew = {
  brandPresetId: 'create',
  name: 'create',
  colors: [],
  defaultColorHexCode: '',
  defaultColorName: '',
  defaultLogo: '',
  description: '',
  isDefault: false,
  organisationId: '',
  proBrandingStatus: 'PRO',
  safeWebFonts: '',
  thumbnail: ''
};

export function BrandPresetProvider({
  getBrandPresetsApi,
  createBrandPresetApi,
  updateBrandPresetApi,
  brandPresetActionsApi,
  getBrandPresetApi,
  fetchAssets,
  assetsMap,
  selectedOrganisation,
  children,
  onSelect: onSelectBrandPreset,
  returnDataType = 'ID',
  displayType = 'LANDING',
  selectedId,
  autoSelectDefault = false,
  disabled
}) {
  const [allBrandPresets, setAllBrandPresets] = useState([]);
  const [presetLoading, setPresetLoading] = useState(true);


  const { organisationId } = selectedOrganisation;

  const handleAutoSelect = (brandPresets) => {
    if (!(autoSelectDefault && displayType === 'SELECT' && onSelectBrandPreset && !selectedId)) {
      return;
    }

    const defaultPreset = brandPresets.find(({ isDefault }) => isDefault) || {};
    const { brandPresetId } = defaultPreset;

    if (Object.keys(defaultPreset).length > 0) {
      const selectedValue = returnDataType === 'ID' ? brandPresetId : defaultPreset;
      onSelectBrandPreset(selectedValue);
    }
  };

  const handleAssetFetching = (brandPresets) => {
    const assetIds = brandPresets.reduce((acc, brand) => [
    ...acc,
    ...(brand.thumbnail ? [brand.thumbnail] : []),
    ...(brand.defaultLogo ? [brand.defaultLogo] : [])],
    []);

    const uniqueAssetIds = [...new Set(assetIds)];

    if (uniqueAssetIds.length > 0) {
      fetchAssets({ assetIds: uniqueAssetIds });
    }
  };

  const getBrandPresetsList = async () => {
    try {
      setPresetLoading(true);
      const { data, error } = await getBrandPresetsApi();

      const newBrandPreset = displayType === 'SELECT' && !disabled ? [createNew] : [];
      if (!error && data) {
        const brandPresets = data.getBrandPresets ? data.getBrandPresets : [];

        setAllBrandPresets([
        ...brandPresets,
        ...newBrandPreset]
        );

        handleAutoSelect(brandPresets);
        handleAssetFetching(brandPresets);
      } else {
        setAllBrandPresets([
        ...newBrandPreset]
        );
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Unexpected error in getBrandPresetsList:', err);
    } finally {
      setPresetLoading(false);
    }
  };

  useEffect(() => {
    getBrandPresetsList();
  }, []);

  const createBrandPreset = async (brandPresetInput) => {
    const brandPreset = _omit(brandPresetInput, ['__typename']);
    const { colors } = brandPreset;

    const { data, error } = await createBrandPresetApi({
      ...brandPreset,
      colors: colors && colors.length > 0 ? colors.map((it) => _omit(it, ['__typename'])) : [],
      organisationId
    });
    if (!error && data) {
      getBrandPresetsList();
      return true;
    }
    return false;
  };

  const updateBrandPreset = async (brandPresetInput) => {
    const brandPreset = _omit(brandPresetInput, ['__typename']);
    const { colors } = brandPreset;

    const { data, error } = await updateBrandPresetApi({
      ...brandPreset,
      colors: colors && colors.length > 0 ? colors.map((it) => _omit(it, ['__typename'])) : [],
      organisationId
    });

    if (!error && data) {
      getBrandPresetsList();
      return true;
    }
    return false;
  };

  return (
    <BrandPresetContext.Provider
      value={{
        state: {
          allBrandPresets,
          assetsMap,
          displayType,
          selectedId,
          returnDataType,
          disabled,
          presetLoading
        },
        actions: {
          setAllBrandPresets,
          getBrandPresetsList,
          createBrandPreset,
          updateBrandPreset,
          updateBrandPresetApi,
          brandPresetActionsApi,
          getBrandPresetApi,
          fetchAssets,
          onSelectBrandPreset
        }
      }}>

      {children}
    </BrandPresetContext.Provider>);

}